import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  public resetPasscodeForm : FormGroup;
  public npass : string;
  public cpass : string;
  public token;
  public student_id;
  public flag = false;
  constructor(private fb : FormBuilder,private _userService : UserService, private router : Router, 
              private route : ActivatedRoute, public log: LogService) { 
    this.resetPasscodeForm = this.fb.group({
      npass: ['', Validators.compose([Validators.required])],
      cpass: ['', Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Reset Password",
      details: `Accessed Reset Password`
    }).subscribe(data => { });
    this.route.paramMap.subscribe((params : ParamMap) => {
      this.token = params.get('t');

    })
  }

  resetPasscode(details){
    this.flag = true;
    const resp = document.querySelector('#resp');
    this.route.paramMap.subscribe((params : ParamMap) => {
      details.value.token = this.token;
      details.value.student_id = this.student_id;
      this._userService.resetPasscode(details.value).subscribe(data => {
        if(data.success){
          resp.setAttribute('class','alert alert-success text-center');
          resp.innerHTML = data.message+". Please proceed to the login page";
        }else if(!data.success){
          resp.setAttribute('class','alert alert-danger text-center');
          resp.innerHTML = data.message;
        }else{
          resp.setAttribute('class','alert alert-danger text-center');
          resp.innerHTML = "Something went wrong";
        }
        this.flag = false;
     });
    })
   
    
   }

}
